//Saving new Item
import { firestore, storage } from "../firebase.config";
import { collection, doc, orderBy, query, setDoc, getDocs, deleteDoc,updateDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage"; // Import ref and deleteObject for storage
import { db } from '../firebase.config';

export const saveItem = async (data) => {
    await setDoc(doc(firestore, 'HomeSlider', `${Date.now()}`), data, { merge: true });
};
export const saveGalleryItem = async (data) => {
    await setDoc(doc(firestore, 'Gallery', `${Date.now()}`), data, { merge: true });
};
export const saveBlogItem = async (data) => {
    await setDoc(doc(firestore, 'Blog', `${Date.now()}`), data, { merge: true });
};
export const saveEventItem = async (data) => {
    await setDoc(doc(firestore, 'Event', `${Date.now()}`), data, { merge: true });
};
export const saveMetricsItem = async (data) => {
    await setDoc(doc(firestore, 'Metrics', `${Date.now()}`), data, { merge: true });
};
export const saveDonationAmountsItem = async (data) => {
    await setDoc(doc(firestore, 'DonationAmounts', `${Date.now()}`), data, { merge: true });
};

export const getAllItems = async () => {
    const itemsQuery = query(collection(firestore, 'Products'), orderBy('id', 'desc'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};
// utils/firebaseFunctions.js

// --- Generic Save Function (for both food and monthly expenses) ---
export const saveExpenseItem = async (data, collectionName) => {
    try {
        const docRef = doc(collection(firestore, collectionName), data.id);
        await setDoc(docRef, data, { merge: true });
        console.log(`Document written to ${collectionName} with ID: `, data.id);
    } catch (e) {
        console.error("Error adding document: ", e);
        throw e; // Re-throw to be caught by the component
    }
};

// --- Generic Fetch Function ---
export const getAllExpenseItems = async (collectionName) => {
    try {
        const items = [];
        const q = query(collection(firestore, collectionName), orderBy("timestamp", "desc")); // Order by timestamp
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            items.push({ ...doc.data(), docId: doc.id });
        });
        return items;
    } catch (e) {
        console.error("Error getting documents: ", e);
        throw e;
    }
};

// --- Generic Delete Function ---
export const deleteExpenseItem = async (docId, collectionName) => {
    try {
        await deleteDoc(doc(firestore, collectionName, docId));
        console.log(`Document from ${collectionName} with ID: ${docId} successfully deleted!`);
    } catch (e) {
        console.error("Error deleting document: ", e);
        throw e;
    }
};

// --- Generic Update Function ---
export const updateExpenseItem = async (docId, updatedData, collectionName) => {
    try {
        const docRef = doc(firestore, collectionName, docId);
        await updateDoc(docRef, updatedData);
        console.log(`Document in ${collectionName} with ID: ${docId} successfully updated!`);
    } catch (e) {
        console.error("Error updating document: ", e);
        throw e;
    }
};

